<template>
  <KTTable
    title="Fuente Baja"
    subtitle="Lista de Fuente Baja"
    :fields="fields"
    :endpoint="endpoint"
    :delete="DELETE_FUENTE_BAJA"
    @edit="editItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_FUENTE_BAJA } from "@/core/services/store/fuenteBaja.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      DELETE_FUENTE_BAJA,
      endpoint: "dic_fuente_bajas",
      fields: [
        {
          key: "id_fuente",
          label: "Código Fuente Baja",
          sortable: true
        },
        {
          key: "descripcion",
          label: "Lieral Fuente Baja",
          sortable: true
        },
        {
          key: "prioridad",
          label: "Prioridad",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    editItem(item) {
      this.$router.push(`${this.$route.path}/${item.id_fuente}`);
    }
  }
};
</script>
